<template>
  <transition>
    <div  v-if="visible" style="width:200px;text-align: center;">
      <img src="../assets/loading1.gif" v-if="loadingType==='circular'"/>
      <img src="../assets/loading2.gif" v-if="loadingType==='loadingStrip'"/>
      <img src="../assets/loading3.gif" v-if="loadingType==='circularStrip'"/>
      <img src="../assets/loading4.gif" v-if="loadingType==='sunlight'"/>
      <div>{{text}}</div>
    </div>
  </transition>
</template>

<script>
    export default {
      props:{
        text:{type:String,default:'加载中'},
        loadingType:{type:String,default:'circular'},
        visible: {type: Boolean, default: true},
      },
      data(){
        return{
        }
      },
      methods:{
        closeLoading(){
          this.close();
        },
      },

    }
</script>

<style scoped>
  .hidden {
    transform: scale(0);
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/loading.vue